import { Pipe, PipeTransform } from '@angular/core';

import { MoneyHelpers } from '@api/util/money.helpers';
import { CurrencyInfo } from '@core/domain/models/store.models';

@Pipe({
    name: 'price',
})
export class PricePipe implements PipeTransform {
    public transform(value: number, currencyInfo: CurrencyInfo): string {
        const formatedPrice: string = MoneyHelpers.formatPriceWithCurrencySymbol(value, currencyInfo);

        return formatedPrice;
    }
}
